module.exports = __webpack_public_path__ + "media/images/help-browser-91560c6f6a87ba49fd1e14039c380c0b.png";